import { UserGroup } from '@models';
import { MutationPayload } from './mutation-payload';

export interface CreateFoundationCommitteesResult {
  createCommittees: CreateCommitteesPayload;
}

export interface CreateCommitteesPayload extends MutationPayload {
  committees: UserGroup[];
}
